import 'expose-loader?exposes[]=XRegExp!xregexp';
